import type { Graph } from './types';

export const graph: Graph = {
  nodes: [
    { id: "case", type: "case", label: "ХД-2026-0142", x: 430, y: 270 },
    { id: "p1", type: "person", label: "Б.Тэмүүлэн", sub: "roleSuspect", x: 280, y: 150 },
    { id: "p2", type: "person", label: "Г.Сараннэмэх", sub: "roleAccomplice", x: 620, y: 130 },
    { id: "p3", type: "person", label: "Ц.Билгүүн", sub: "roleAccomplice", x: 660, y: 330 },
    { id: "p4", type: "person", label: "Д.Оюунчимэг", sub: "roleWitness", x: 250, y: 380 },
    { id: "org", type: "org", label: "«Хар шувуу» бүлэглэл", x: 470, y: 60 },
    { id: "sub1", type: "substance", label: "Метамфетамин", x: 130, y: 250 },
    { id: "place", type: "place", label: "Замын-Үүд хил", x: 800, y: 210 },
    { id: "p5", type: "person", label: "Т.Идэрбат", sub: "roleSuspect", x: 810, y: 90 },
  ],
  edges: [
    { from: "p1", to: "case", rel: "relInvolved" },
    { from: "p2", to: "case", rel: "relInvolved" },
    { from: "p3", to: "case", rel: "relInvolved" },
    { from: "p4", to: "case", rel: "relInvolved", dashed: true },
    { from: "p1", to: "org", rel: "relMember" },
    { from: "p2", to: "org", rel: "relMember" },
    { from: "p5", to: "org", rel: "relBoss" },
    { from: "p1", to: "sub1", rel: "relSell" },
    { from: "p5", to: "place", rel: "relSupply" },
    { from: "p2", to: "place", rel: "relLocation", dashed: true },
    { from: "p3", to: "p1", rel: "relBuy" },
  ],
};
